var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',{staticClass:"blog"},_vm._l((_vm.posts),function(post,index){return _c('Post',{key:("post-" + index),attrs:{"title":post.title,"lead":post.lead,"content":post.content,"slug":post.slug}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }